import React from 'react';
import { getCoachAiName } from 'utils/i18n';
import { MINDSET_CARD_ID, useMindsetCardAgent, useMindsetSituationalAwareness } from 'utils/mindset';
import { useFetchUserMindsetSettings } from 'actions/userProfile';
import CenterContent from 'components/CenterContent';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import Flex from 'components/Flex';
import Landmark from 'components/Landmark';
import PageBackLink from 'components/PageBackLink';
import PageSection from 'components/PageSection';
import PageTitle from 'components/PageTitle';
import MindsetAgentCard from 'components/MindsetAgentCard';
import { HOME_ROUTE } from '../../../routes';
import ErrorScreen from '../errors/ErrorScreen';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CoachAI() {
  var _useMindsetCardAgent = useMindsetCardAgent(),
    mindsetLoadingStatus = _useMindsetCardAgent.mindsetLoadingStatus,
    setMindsetLoadingStatus = _useMindsetCardAgent.setMindsetLoadingStatus,
    hasInitialized = _useMindsetCardAgent.hasInitialized,
    renderGeneration = _useMindsetCardAgent.renderGeneration;
  useMindsetSituationalAwareness(hasInitialized, MINDSET_CARD_ID, renderGeneration);
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(PageBackLink, {
      fallback: HOME_ROUTE,
      mb: "xs"
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      mb: "s",
      gap: "xs",
      children: [/*#__PURE__*/_jsx(CoachAiAvatar, {
        size: "big"
      }), /*#__PURE__*/_jsx(PageTitle, {
        size: "large",
        children: getCoachAiName()
      })]
    }), /*#__PURE__*/_jsx(MindsetAgentCard, {
      mindsetLoadingStatus: mindsetLoadingStatus,
      onLoad: function onLoad() {
        return setMindsetLoadingStatus('success');
      }
    })]
  });
}
function CoachAiAccessWrapper(_ref) {
  var children = _ref.children;
  var _useFetchUserMindsetS = useFetchUserMindsetSettings(),
    hasMindsetAgent = _useFetchUserMindsetS.hasMindsetAgent,
    isLoading = _useFetchUserMindsetS.isLoading;
  if (isLoading) {
    return /*#__PURE__*/_jsx(CenterContent, {
      fillParent: true,
      children: /*#__PURE__*/_jsx(Landmark, {
        icon: "spinner"
      })
    });
  }
  if (hasMindsetAgent) {
    return children;
  }
  return /*#__PURE__*/_jsx(ErrorScreen, {});
}
function ProtectedCoachAi() {
  return /*#__PURE__*/_jsx(CoachAiAccessWrapper, {
    children: /*#__PURE__*/_jsx(CoachAI, {})
  });
}
export default ProtectedCoachAi;